export default "__VITE_ASSET__d549c262__"